/** @format */

import type { FC } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeIcon from "./assets/icons/home.svg?react";
import ExamGeneratorIcon from "./assets/icons/exam-generator.svg?react";
import SearchIcon from "./assets/icons/search.svg?react";
import PastPapersIcon from "./assets/icons/past-papers.svg?react";
import { Locale } from "../../features/i18n/init";

interface NavItem {
	to: string;
	labelKey: string;
	icon: FC<{ className?: string }>;
	isEnd?: boolean;
}

const itemBaseStyle =
	"group flex flex-col items-center justify-center gap-1.5 rounded-xl px-2 py-3 text-center text-sm font-medium " +
	"text-(--public-color-menu-label) transition-colors " +
	"hover:bg-(--public-color-menu-hover-bg) " +
	"focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--public-color-theme-primary)";

const activeItemStyle = "bg-(--public-color-menu-active-bg) text-(--public-color-menu-active-label)";

const getItemClassName = ({ isActive }: { isActive: boolean }) => `${itemBaseStyle} ${isActive ? activeItemStyle : ""}`;

export const MainNavigation = () => {
	const { t } = useTranslation();
	const { locale } = useParams<{ locale: Locale }>();
	const navItems: NavItem[] = [
		{ to: `/${locale}`, labelKey: "mainMenu.home", icon: HomeIcon, isEnd: true },
		{ to: `/${locale}/exam-generator`, labelKey: "mainMenu.examGenerator", icon: ExamGeneratorIcon },
		{ to: `/${locale}/search`, labelKey: "mainMenu.search", icon: SearchIcon },
		{ to: `/${locale}/past-papers`, labelKey: "mainMenu.pastPapers", icon: PastPapersIcon },
	];
	return (
		<nav aria-label="Main menu" className="w-full">
			<ul className="flex flex-row justify-around gap-1 md:flex-col md:justify-start md:gap-2">
				{navItems.map((item) => {
					const Icon = item.icon;
					return (
						<li key={item.to} className="flex-1 md:flex-none">
							<NavLink to={item.to} end={item.isEnd} className={getItemClassName}>
								<Icon className="h-6 w-6 text-(--public-color-text-lighter) group-aria-[current=page]:text-(--public-color-text-default)" />
								<span>{t(item.labelKey)}</span>
							</NavLink>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};
